var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-default-app-bar',{attrs:{"back-to":false}},[_c('div',{staticClass:"d-flex align-center custom-header"},[_c('v-btn',{staticClass:"mr-2",attrs:{"icon":""},on:{"click":_vm.voltar}},[_c('v-icon',[_vm._v("mdi-arrow-left")])],1),_c('span',{staticClass:"pl-2 text-h6"},[_vm._v("Pré-Cadastro")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }